import React from 'react';
import {
  Path,
  Rect,
  Circle,
  Line,
  Polygon,
  Polyline,
  Svg,
} from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const CommentIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M17.2286 13.1143V0.771429H0.771429V17.2286L4.88571 13.1143H17.2286Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </Svg>
);

CommentIcon.displayName = 'CommentIcon';
